module.exports = __webpack_public_path__ + "img/feature-tile-icon-08.6b70df7d.svg";